module.exports = __webpack_public_path__ + "media/videos/home/hero-desktop-f8bf7e7963df3c167e6ef6c4ae6bf49b.mp4";